import axios from 'axios'
import utils from './utils'

const axiosPublic = axios.create({
  baseURL: utils.url,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
})

let publicToken = null
let publicTokenExpiresAt = 0
let publicTokenRequest = null

const clearPublicToken = () => {
  publicToken = null
  publicTokenExpiresAt = 0
}

const getPublicToken = async () => {
  const now = Date.now()
  if (publicToken && now < publicTokenExpiresAt) return publicToken

  if (!publicTokenRequest) {
    publicTokenRequest = axios
      .get(`${utils.url}/public-token`)
      .then((response) => {
        publicToken = response.data.access_token
        // Le token API dure 10 minutes. On le renouvelle une minute avant son expiration.
        publicTokenExpiresAt = Date.now() + 9 * 60 * 1000
        return publicToken
      })
      .finally(() => {
        publicTokenRequest = null
      })
  }

  return publicTokenRequest
}

axiosPublic.interceptors.request.use(async (config) => {
  const token = await getPublicToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axiosPublic.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config
    if (error.response?.status === 401 && originalRequest && !originalRequest._publicRetry) {
      originalRequest._publicRetry = true
      clearPublicToken()
      const token = await getPublicToken()
      originalRequest.headers.Authorization = `Bearer ${token}`
      return axiosPublic(originalRequest)
    }
    return Promise.reject(error)
  },
)

export default axiosPublic
